import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { string, node } from 'prop-types';

const propTypes = {
  title: string,
  background: string,
  children: node,
};

const defaultProps = {
  title: null,
  background: null,
  children: null,
};

const SmallHero = ({ title, background, children }) => {
  const heroBg = {
    backgroundImage: `url(${background})`,
  };

  return (
    <section
      className="c-section c-section--small-hero d-flex flex-column"
      style={heroBg}
    >
      {children}
      <Container className="mt-5">
        <Row>
          <Col lg={7}>
            <h2 className="text-white fw-bold mb-0">{title}</h2>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

SmallHero.propTypes = propTypes;
SmallHero.defaultProps = defaultProps;

export default SmallHero;
